import { ContentfulImage2 } from "../../_shared-components/image-related/ContentfulImage2";
import React from "react";
import { css } from "@emotion/react";
import { CSS_MQ } from "../../../styles/breakpoints";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { ImageWithFocalPointType } from "@swo/shared";

export const GSBackgroundBlurredImage: ReactTFC<{
  background: ImageWithFocalPointType | undefined;
  className?: string;
}> = props => {
  return props.background ? (
    <ContentfulImage2
      assetId={props.background.image.sys.id}
      key={props.background.image.url + "small"}
      contentfulUrl={props.background.image.url}
      cropping={{
        focalPoint: props.background.focalPoint,
        image: props.background.image,
      }}
      css={smallBackgroundImageStyles}
      sizes="(max-width: 1200px) 100vw, 1200px"
      quality={10}
      withTransparency={false}
      className={props.className}
    />
  ) : null;
};

const smallBackgroundImageStyles = css`
  display: none;

  ${CSS_MQ.atLeastMd} {
    display: block;
  }

  object-fit: cover;
  filter: brightness(70%) blur(50px);

  width: calc(100% + 50px);
  height: calc(100% + 50px);
  position: absolute;
  z-index: -1;
  top: -25px;
  left: -25px;
`;
